<script>
import catalog from '@/mixins/catalog';

    export default {
        name:"swiper-custom",
        //components:{"vuebox": Vuebox},
        props: {options: {
            type: Object,
            required: true
            },
            photos:{
                type: Array,
                required: false,
                default: () => [],
            },
            photosBox:{
                type: Array,
                required: false,
                default: () => [],
            },
            keySwiper:{
                type: String,
                required: false,
                default: () => "default",
            },
            // атрибут pagination-dynamic-bullets на swiper-container: у блоков
            // с пулями-пагинацией включён (как раньше); блокам со своей
            // навигацией (pagination: false) его нужно снять — иначе парсер
            // параметров падает: dynamicBullets на булевом false
            dynamicBullets:{
                type: Boolean,
                required: false,
                default: () => true,
            }
        },
        mixins:[catalog],
        data: function(){
            return {

                activeIndex:0,
                countSlides:0,
                resizeTimer:null
            }
         },

         watch: {

           
            // Отслеживаем изменения в массиве photos
            photos: {
                handler() {

                    //console.log("Изменен");
                    this.initSwiper(); 
                    // Обновляем Swiper при изменении данных
                    this.updateCount();
                },
                deep: true, // Чтобы отслеживать глубокие изменения массива
            },

            keySwiper: {
                handler() {

                    //console.log("Изменен");
                    this.initSwiper(); 
                    // Обновляем Swiper при изменении данных
                    this.updateCount();
                },
                deep: true, // Чтобы отслеживать глубокие изменения массива
            },
        
         
        },
        mounted: function()
        {
            this.initSwiper();
            this.updateCount();
            // поворот планшета: инлайновая высота иначе остаётся от старой ширины
            window.addEventListener('resize', this.onWindowResize);

        },

        destroyed: function()
        {
            window.removeEventListener('resize', this.onWindowResize);
            clearTimeout(this.resizeTimer);
        },

        methods:{

            initSwiper()
            {
                let options = this.options;

                this.$nextTick(() => {

                    let elem = this.$refs.customGallery;
                                        // now we need to assign all parameters to Swiper element
                    Object.assign(elem, options);

                    elem.initialize();

                    const firstImage = this.$refs.customGallery.querySelector('img');
                    if (firstImage) {
                        if (firstImage.complete) {
                            this.setSwiperHeight(); // Если изображение уже загружено
                        } else {
                            firstImage.addEventListener('load', this.setSwiperHeight, { once: true }); // Если изображение еще загружается
                        }
                    } else {
                        // Если изображений нет, сразу устанавливаем высоту
                        this.setSwiperHeight();
                    }


                });
            },

            setSwiperHeight()
            {
                const swiper = this.$refs.customGallery && this.$refs.customGallery.swiper;
                if (!swiper) {
                    return;
                }
                const activeSlide = swiper.slides[swiper.activeIndex];
                if (!activeSlide) {
                    return;
                }
                this.$refs.swiperBlock.style.height = `${activeSlide.offsetHeight}px`;
            },

            onWindowResize()
            {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(this.setSwiperHeight, 150);
            },

            onSwiperInitMain(event) {
                             
               
                //this.updateCount();
               
            },

            onUpdate()
            {
                //console.log("Dsds");
            },

            updateCount()
            {

               

                this.$nextTick(() => {

                    

                    const swiper = this.$refs.customGallery.swiper;
                    this.countSlides =  swiper.slides.length;

   

                    
                    // Получаем количество слайдов
                   
                });
            },

            onSwiperUpdate()
            {
                //this.activeIndex = 0;
                // console.log("rep");
                // this.initSwiper();
                // this.updateCount();
            },

            handleSlideChange(event) {
                // Получаем текущий индекс активного слайда
                this.activeIndex = event.detail[0].realIndex;

                // Картинка неактивного слайда появляется в DOM только при
                // активации (v-if по activeIndex) и грузится лениво — меряем
                // высоту после её загрузки, иначе высота остаётся от слайда 0
                this.$nextTick(() => {
                    const swiper = this.$refs.customGallery && this.$refs.customGallery.swiper;
                    if (!swiper) {
                        return;
                    }
                    const activeSlide = swiper.slides[swiper.activeIndex];
                    const img = activeSlide && activeSlide.querySelector('img');
                    if (!img || img.complete) {
                        this.setSwiperHeight();
                    } else {
                        img.addEventListener('load', this.setSwiperHeight, { once: true });
                    }
                });

                // Передаем индекс родителю через $emit
                this.$emit('active-slide-changed', this.activeIndex);
            },

            showGallery()
            {
                                // this.activeGallery = gallery;
                                // this.$modal.show('photo-gallery');
                                // this.modalGallery = true;
                                // console.log(this.activeGallery);

                                if(this.photosBox.length > 0)
                                {
                                    let arrImages = [];
                                    
                                    if(this.photosBox[0].VALUE_FILE)
                                    {
                                        
                                        this.photosBox.forEach((element) => {
                                                
                                            arrImages.push(element.VALUE_FILE);
                                        });
                                    }
                                    else
                                    {
                                        arrImages = this.photosBox;
                                    }

                                    this.openGalleryFull(arrImages, this.activeIndex);
                                }
                             
            },


            nextFull()
            {
                this.$refs.customGallery.swiper.slideNext();
            },

            prevFull()
            {
                this.$refs.customGallery.swiper.slidePrev();
            },

            goTo(index)
            {
                const swiper = this.$refs.customGallery && this.$refs.customGallery.swiper;
                if (swiper) {
                    swiper.slideTo(index);
                }
            },
        
        }

    }
</script>

<style>

    .slider-wrapper
    {
        position: relative;
    }

</style>


<template>
    

    <div class="slider-wrapper" ref="swiperBlock">
                <swiper-container
                        init="false"
                        ref="customGallery"
                        @swiperslidechange="handleSlideChange"
                        @swiperinit="onSwiperInitMain"
                        @swiperactiveindexchange="onUpdate"
                        @swiperobserverupdate="onSwiperUpdate"
                        lazy="true"
                        :pagination-dynamic-bullets="dynamicBullets ? 'true' : null"
                        :key="keySwiper"
                        >
                        
                    <slot v-if="photos.length < 1"></slot>

                    <swiper-slide v-if="photos.length > 0" v-for="(photo, index) in photos" :key="index" lazy="true">
                                    <a href="#" @click.prevent.default="showGallery()">
                                        <img v-if="index == 0" :src="photo.src" :width="photo.width" :height="photo.height" loading="lazy" class="swiper-lazy">
                                        <img v-if="index > 0 && activeIndex == index" :src="photo.src" :width="photo.width" :height="photo.height" ref="lazyImage" loading="lazy"  class="swiper-lazy">
                                    </a>
                                </swiper-slide>
                                <!-- <div class="swiper-pagination"></div> -->
                </swiper-container>
                <div class="images-controls" v-if="this.countSlides > 1">
                        <button class="images-controls__btn gallery__prev-btn" @click="prevFull">
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.13 13.3387L8.12 12.3487L3.45669 7.6875L17.25 7.6875V6.3125L3.45669 6.3125L8.11931 1.65125L7.12931 0.661246L1.28556 6.505L0.813936 7L1.28625 7.495L7.13 13.3387Z" fill="#005AA3" />
                            </svg>
                        </button>
                        <button class="images-controls__btn gallery__next-btn" @click="nextFull">
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.87 0.661255L9.88 1.65125L14.5433 6.3125H0.75V7.6875H14.5433L9.88069 12.3488L10.8707 13.3388L16.7144 7.495L17.1861 7L16.7138 6.505L10.87 0.661255Z" fill="#005AA3" />
                            </svg>
                        </button>
                </div>

    </div>

</template>